module.exports = __webpack_public_path__ + "img/IMG_2458.3f2a4a75.jpg";